/*
  Get the current region from the URL

  Supports:
    dev-web-cn.ffau.to
    faradayfuturecn.com
    localhost:xxxx/cn/
    dev-genesis.ffau.to/cn
    genesis.ff.com/cn
*/

const getRegion = url => (/(-cn.ffau.to|faradayfuturecn.com|(:[\d]{4,5}|.to|.com)\/cn)/.test(url) ? 'CN' : 'US');

export default getRegion;
